export enum SimType {
  ProgrammableWireless = 'Programmable Wireless',
  SuperSIM = 'Super SIM',
  Mock = 'Mock',
}

export function getUpdatableSimStates(simType: SimType) {
  switch (simType) {
    case SimType.ProgrammableWireless:
      return ['active', 'ready', 'suspended'];
    case SimType.Mock:
    case SimType.SuperSIM:
      return ['active', 'inactive', 'ready'];
  }
}
